import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useEffect, useRef } from "react";
import { InlineWidget } from "react-calendly";

import {
	useIsPipedriveSuccess,
	useScroll,
	useSetScroll,
} from "~franchise-website/states";
import ContactForm from "~franchise-website/views/landingPages/Franchise/components/Contact";

const CallToAction = () => {
	const isPipedriveSuccess = useIsPipedriveSuccess();
	const scroll = useScroll();
	const setScroll = useSetScroll();

	const myRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (myRef && scroll) {
			myRef.current?.scrollIntoView?.({ behavior: "smooth", block: "start" });
			setScroll(false);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [myRef, scroll]);

	return (
		<Box ref={myRef}>
			<Box
				display="flex"
				flexDirection="column"
				justifyContent="space-between"
				alignContent="center"
				alignItems={{ xs: "flex-start", sm: "flex-start", md: "center" }}>
				{isPipedriveSuccess ? (
					<>
						<Box marginBottom={4}>
							<Typography
								variant="h3"
								fontWeight={700}
								gutterBottom
								align="center">
								Thanks for contacting us! A franchise territory specialist will
								be in touch soon!
							</Typography>
							<Typography
								variant="h6"
								color="text.secondary"
								align="center">
								Don&apos;t want to wait? Book a strategy call now
							</Typography>
						</Box>
						<Box width="35%">
							<InlineWidget url="https://calendly.com/mango_demo/demo?back=0" />
						</Box>
					</>
				) : (
					<>
						<Box marginBottom={4}>
							<Typography
								variant="h3"
								fontWeight={700}
								gutterBottom
								align="center">
								Gain a competitive edge today.
							</Typography>
							<Typography
								variant="h6"
								color="text.secondary"
								align="center">
								Get in touch today to see exactly how Mango can assist your
								franchise development plans.
							</Typography>
						</Box>
						<Box>
							<ContactForm />
						</Box>
					</>
				)}
			</Box>
		</Box>
	);
};

export default CallToAction;
